import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  Spinner,
} from "@fluentui/react-components";

import { useSelectedUsersContext } from "../context/SelectedUsersContext";
import { useDeleteUser } from "../hooks/useUserMutations";
import { useNotify } from "../../../shared/components/SuperToast";
import { useTranslation } from "react-i18next";

function UserDeleteDialog({ isOpen, setIsOpen }) {
  const { t } = useTranslation();
  const { value: selectedUsers } = useSelectedUsersContext();
  const { notify } = useNotify();

  const {
    mutate: mutateDeleteUser,
    error,
    isPending,
  } = useDeleteUser(
    "users",
    () => {
      notify(t("item.messages.deleted", { name: selectedUsers[0].name }), "success");
      setIsOpen(false);
    },
    null,
  );

  const handleConfirmation = () => {
    const publicId = selectedUsers?.[0]?.public_id;
    if (!publicId) throw new Error("No valid ID for user");
    console.log(`Deleting user with id ${publicId}`);
    mutateDeleteUser(publicId);
  };

  if (!selectedUsers?.[0]) return null;

  return (
    <Dialog modalType="alert" open={isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>
            {t("generic.delete")} {selectedUsers[0]?.fname} {selectedUsers[0]?.lname}
          </DialogTitle>
          <DialogContent>
            {t("item.questions.delete", {
              name: selectedUsers[0]?.name,
            })}
            {error && <div style={{ color: "red" }}>{error.message}</div>}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <Button appearance="primary" disabled={isPending} onClick={handleConfirmation}>
            {isPending ? <Spinner size="tiny" /> : t("generic.confirm")}
          </Button>
          <Button appearance="secondary" disabled={isPending} onClick={() => setIsOpen(false)}>
            {t("generic.cancel")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default UserDeleteDialog;
